import * as React from 'react';

import { CatalogAdminEditionClientProvider } from '@/api/catalog-client-context';
import { HttpCatalogAdminEditionClient } from '@/api/catalog-edition-client.http';
import { CatalogSkillsScreen } from '@/routes/admin/catalog/catalog-skills-screen';

// =============================================================================
// catalog-skills-route.tsx — Adaptateur routeur du référentiel compétences A-25 (S9-D4).
// =============================================================================
// Route `/admin/catalog/skills` (MONDE ADMIN d'ÉCRITURE, P-05, distincte des lectures S8).
// Le BC catalog AUTO-PORTE son DI seam d'écriture : la route enveloppe l'écran avec le
// CatalogAdminEditionClientProvider. Depuis S20 (DEC-S20-B2, D2a-MUT), la route injecte
// l'adaptateur HTTP réel — sinon l'écran d'écriture défautait sur le stub in-memory et
// n'atteignait jamais l'API (reachability : mutation non effective).

const catalogSkillsClient = new HttpCatalogAdminEditionClient();

export function CatalogSkillsRoute(): React.JSX.Element {
  return (
    <CatalogAdminEditionClientProvider client={catalogSkillsClient}>
      <CatalogSkillsScreen />
    </CatalogAdminEditionClientProvider>
  );
}
